import styled from 'styled-components';

var Surface = styled('div').withConfig({
  componentId: "sc-storm-ui-30075085__sc-1jut9pn-0"
})(["background-color:", ";color:", ";"], ({
  theme
}) => theme.surface.backgroundColor, ({
  theme
}) => theme.typography.body.bodyFontColor);

export { Surface as S };
//# sourceMappingURL=Surface-B_3cEoAZ.js.map
